import useTranslator from "../../hooks/useTranslator";
import PasswordInput from "./PasswordInput";

const PasswordForm = ({
  title,
  subtitle,
  isTwo,
  isProvidePassword = true,
  passwordValue,
  onChangePassword,
  repeatPasswordValue,
  submitHandler,
  disabled,
  setCurrentScreen,
  sendOtpFun,
  inputError,
  setInputError
}) => {
  const { _t } = useTranslator();
  return (
    <form onSubmit={submitHandler} className="formInformation passwordFormInfo">
      <h2>
        <img
          onClick={() => setCurrentScreen("emailScreen")}
          src="/images/arrow-right.svg"
          className="arrowBack"
        />
        {title}
      </h2>
      <p>{subtitle}</p>
      <PasswordInput
        name="password"
        onChange={onChangePassword}
        value={passwordValue}
        inputError={inputError}
        setInputError={setInputError}
        isShowChecks={isTwo}
      />
      {isProvidePassword && (
        <a
          onClick={() => setCurrentScreen("forgotPassword")}
          className="forgotPassword"
        >
          {_t("forgotPassword")}
        </a>
      )}
      {isTwo && (
        <PasswordInput
          name="confirmPassword"
          value={repeatPasswordValue}
          label={_t("repeatPassword")}
          onChange={onChangePassword}
          inputError={inputError}
          setInputError={setInputError}
        />
      )}
      {inputError && (
        <p className="error-message">{inputError}</p>
      )}
      <button
        disabled={disabled}
        type="submit"
        className="btnNext basicInfoButton greenHover"
      >
        {_t("submit")}
      </button>
      {isProvidePassword && (
        <p className="continueWithOtp">
          {_t("continueWithOtp")}
          <a
            onClick={() => {
              sendOtpFun();
              setCurrentScreen("verifyOTP");
            }}
            className="forgotPassword"
          >
            {_t("clickHere")}
          </a>
        </p>
      )}
    </form>
  );
};

export default PasswordForm;
